<ejs-autocomplete #autocomplete
                  placeholder="{{placeholder | translate}}"
                  autofill="true"
                  [dataSource]="data"
                  [fields]="fields"
                  [allowFiltering]="true"
                  [allowObjectBinding]="allowObjectBinding"
                  [(value)]="outputValue"
                  highlight = "true"
                  [cssClass]="cssClass"
                  [enabled]="enabled"
                  (blur)="onBlur()"></ejs-autocomplete>
